import withAuth from 'ecommerce/hoc/withAuth';

import ReferFriendLanding from '../components/referFriend/landing';
import ReferFriendSignedIn from '../components/referFriend/signedIn';

// Signed-in visitors get their code, share actions and referral stats. Signed-out visitors and
// crawlers get the public promo page, its CTAs go to sign-in and return here (docs/refer-friend.md).
export default withAuth(ReferFriendSignedIn, ReferFriendLanding);
